export default "__VITE_ASSET__q04j$hZ8__"